import React, { useState } from "react";
import { TEAL } from "./constants";

export default function UnsplashPanel({ onSearch, onPick, onFillMoodboard, onClose }) {
  const [query, setQuery] = useState("");
  const [photos, setPhotos] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [searched, setSearched] = useState(false);

  const run = async (e) => {
    e?.preventDefault?.();
    if (!query.trim() || busy) return;
    setBusy(true);
    setError(null);
    const result = await onSearch(query.trim());
    setBusy(false);
    setSearched(true);
    if (!result.ok) { setError(result.error); setPhotos([]); return; }
    setPhotos(result.photos || []);
  };

  return (
    <div
      className="absolute left-3 top-3 z-[60] rounded-xl border border-black/[0.08] shadow-[0_10px_30px_rgba(0,0,0,0.18)] font-['DM_Sans']"
      style={{ background: "#FFFFFF", width: 320, maxHeight: "72%", display: "flex", flexDirection: "column" }}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-between px-3 py-2 border-b border-black/[0.06] flex-shrink-0">
        <div>
          <div className="text-[12px] font-bold text-slate-800 leading-none">Reference images</div>
          <div className="text-[10px] text-slate-400 pt-[3px] leading-none">Photos from Unsplash</div>
        </div>
        <button type="button" onClick={onClose} title="Close"
          className="text-slate-400 text-[16px] leading-none bg-transparent border-none cursor-pointer px-1">
          ✕
        </button>
      </div>

      <form onSubmit={run} className="flex gap-2 px-3 py-2 flex-shrink-0">
        <input
          autoFocus
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search photos…"
          className="flex-1 text-[12px] px-2 py-[6px] rounded-md border border-black/10 outline-none text-slate-700"
        />
        <button type="submit" disabled={busy || !query.trim()}
          className="text-[11px] font-semibold px-3 rounded-md cursor-pointer border-none text-white disabled:opacity-45"
          style={{ background: TEAL }}>
          {busy ? "…" : "Search"}
        </button>
      </form>

      <div className="overflow-y-auto px-3 pb-2" style={{ minHeight: 0 }}>
        {error && <p className="text-[11px] text-red-500 m-0 py-2">{error}</p>}

        {!error && searched && !busy && photos.length === 0 && (
          <p className="text-[11px] text-slate-400 m-0 py-2">Nothing found for that.</p>
        )}

        <div className="grid grid-cols-2 gap-[6px]">
          {photos.map((p) => (
            <div key={p.id} className="rounded-lg overflow-hidden border border-black/[0.06]">
              <button type="button" onClick={() => onPick(p)} title={p.alt}
                className="block w-full p-0 border-none bg-transparent cursor-pointer">
                <img src={p.thumb} alt={p.alt} className="block w-full h-[84px] object-cover" />
              </button>
              <div className="px-[5px] py-[3px] text-[8.5px] text-slate-400 leading-tight truncate">
                <a href={p.profileUrl} target="_blank" rel="noreferrer noopener"
                  className="text-slate-500 no-underline hover:underline">
                  {p.photographer}
                </a>
                {" on "}
                <a href={p.photoUrl} target="_blank" rel="noreferrer noopener"
                  className="text-slate-500 no-underline hover:underline">
                  Unsplash
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      {photos.length > 0 && (
        <div className="flex items-center gap-2 px-3 py-2 border-t border-black/[0.06] flex-shrink-0">
          <button type="button" onClick={() => onFillMoodboard(photos)}
            className="text-[11px] font-semibold px-2 py-[5px] rounded-md cursor-pointer border"
            style={{ color: TEAL, borderColor: "rgba(77,184,181,0.4)", background: "rgba(77,184,181,0.10)" }}>
            Fill a moodboard
          </button>
          <span className="ml-auto text-[10px] text-slate-400">{photos.length} photos</span>
        </div>
      )}
    </div>
  );
}
